module.exports = __webpack_public_path__ + "static/media/HomePage_Header@2x.e247294a.png";